import CollectionPanel from './CollectionPanel';

export default CollectionPanel;



// WEBPACK FOOTER //
// ./src/scenes/Store/components/CollectionPanel/index.ts